import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getCurrentUserRole } from '../../helpers/AuthHelper';
import { LOCO_SUPER, MARKETING } from '../../constants/Auth';
import actions from '../../store/actions';

import InternalSidebar from './../../components/UI/InternalSidebar/InternalSidebar';
import PrivateContainer from './../../components/UI/PrivateContainer/PrivateContainer';
import { ReactComponent as ReactImgPerson } from '../../assets/images/social/profile-dark.svg';
import { ReactComponent as ReactImgNews } from '../../assets/images/marketing/news.svg';

import CreateArticle from 'components/MarketingSettings/News_Admin/createarticle';

class MarketingSettingsContainer extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
  };
  state = {
    sideNavs: [],
    brandFeatures: {},
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.brandFeatures !== prevState.brandFeatures) {
      const { brandFeatures, userDetails } = nextProps;
      const sideNavs = [
        {
          name: 'Add News',
          link: 'addnews/',
          icon: ReactImgNews,
          userRoles: [LOCO_SUPER, MARKETING],
        }
      ];

      return {
        brandFeatures,
        sideNavs: sideNavs.filter((item) => item),
      };
    }

    return null;
  }

  componentDidMount() {}

  isCurrentTab(link) {
    return new RegExp(`/[^/]+/${link}`).test(this.props.location.pathname);
  }

  renderSideNavs = () => {
    const { sideNavs } = this.state;
    const renderedSideNavs = sideNavs.map((nav) => (
      <PrivateContainer allowRoles={nav.userRoles} key={nav.link}>
        <Link to={this.props.match.path + nav.link}>
          <div
            className={`account-settings__item f-sz-l f-w-semi-bold ${
              this.isCurrentTab(nav.link) ? 'current_tab' : ''
            }`}>
            {nav.icon ? <nav.icon className="nav-logo" /> : null}
            <div className="nav-name">{nav.name}</div>
          </div>
        </Link>
      </PrivateContainer>
    ));

    const currentUserRole = getCurrentUserRole();
    const firstSideNav = sideNavs.find((nav) => nav.userRoles.includes(currentUserRole));
    const firstLink = (firstSideNav && firstSideNav.link) || 'profile';

    return [renderedSideNavs, firstLink];
  };

  render() {
    const [renderedSideNavs, firstLink] = this.renderSideNavs();
    const allBrands =
      (Array.isArray(this.props.allBrands) &&
        this.props.allBrands.length > 0 &&
        this.props.allBrands) ||
      (Array.isArray(this.props.factoryBrandsList) &&
        this.props.factoryBrandsList.length > 0 &&
        this.props.factoryBrandsList) ||
      [];
    return (
      <div className="account-settings__wrapper flex-col">
        <Helmet
          bodyAttributes={{
            class: 'body_container',
          }}
        />
        <div className="account-settings flex">
          <InternalSidebar theme="users-sidebar">{renderedSideNavs}</InternalSidebar>
          <div className="account-settings__content flex">
            <Route
              exact
              path={this.props.match.path}
              render={(routeProps) => {
                return <Redirect {...routeProps} to={this.props.match.path + firstLink} />;
              }}
            />
            <Route
              path={this.props.match.path + 'addnews'}
              userRoles={[LOCO_SUPER, MARKETING]}
              render={(routeProps) => (
                <CreateArticle
                  {...routeProps}
                  currentUser={this.props.userDetails}
                  openModal={this.props.openModal}
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  openModal: (content, additionalProps) => dispatch(actions.openModal(content, additionalProps)),
  closeModal: () => dispatch(actions.closeModal()),
  showFlashMsg: (details) => dispatch(actions.flash(details)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketingSettingsContainer);
